import { GalleryDto } from '@nusign/picflow-backend-types';
import { sortGalleries } from './sort-galleries';

export const sortSubGalleries = (galleries: GalleryDto[], sorting: string) => {
  sorting = sorting || 'created_at';
  if (sorting === 'last_changed_at') sorting = '-last_changed_at';
  if (sorting === 'created_at') sorting = '-created_at';

  const sortedGalleries = galleries.slice();
  sortGalleries(sortedGalleries, sorting);
  return sortedGalleries;
};
